<template>
  <v-dialog v-model="show" persistent max-width="300">
    <v-card>
      <v-card-title class="headline"> </v-card-title>
      <v-card-text>
        <p>
          <v-progress-circular
            indeterminate
            color="primary"
            class="mr-2"
            v-if="isProgressMode()"
          ></v-progress-circular>
          {{message}}
        </p>
      </v-card-text>
      <v-card-actions v-if="isInfoMode()" class="d-flex justify-end px-4 pb-4">
        <v-btn class="ma-2" @click="hideDialog()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProgressDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default : "Work in progress"
    },
    mode: {
      type: String,
      default: "info"
    }
  },
  methods: {
    isProgressMode() {
      return this.mode === 'progress';
    },
    isInfoMode() {
      return this.mode === 'info';
    },
    hideDialog() {
      this.$emit("onClose", true);
    }
  }
};
</script>